const Feedback = ({ feedback }) => {
  if (!feedback) return null;
  
  return (
    <div className={`mt-3 sm:mt-5 p-3 sm:p-4 rounded-xl text-sm sm:text-lg font-bold text-center animate-bounce ${
      feedback.type === 'success'
        ? 'bg-green-100 text-green-800 border-2 border-green-500'
        : 'bg-red-100 text-red-800 border-2 border-red-500'
    }`}>
      {feedback.message}
    </div>
  );
};

export default Feedback;